/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 6/24/19
 * Time: 2:05 PM
 */
export const CLIENT_SECRET = "Y2V5ZW50cmE6"; // "Y2V5ZW50cmE6QXRBMWlmTTRoSzBzTUsyYWhpOEtScDF6aGlBWDE4YnJzNGo1MWl0MG00eWw2MkRBYTkydkEzV3M4UTgxS3RoNWFzTW4wcG01";
export const CLIENT_ID = "ceyentra";
export const GOOGLE_LOCATION_KEY = "AIzaSyD9Juj4XYGRnE19y6p6-urYftTDEEafGkU";
export const GOOGLE_SIGN_UP_ID = "938968550560-8seism1olrhs9qq18h8qokc55v9u6j8a.apps.googleusercontent.com"
export const FACEBOOK_SIGN_UP_ID = "934200254250369"
export const APPLE_SIGN_UP_ID = "com.ceyentra.tagslk"
export const APPLE_SIGN_UP_REDIRECT_URI = "https://tags.lk/public/web-sign-up"

export const DIALOG_PRIVACY_POLICY = "https://dlg.dialog.lk/privacy-notice";
